import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import PercentIcon from "@mui/icons-material/Percent";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import GppGoodIcon from "@mui/icons-material/GppGood";
import GppBadIcon from "@mui/icons-material/GppBad";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { LoaderScreen } from "../../components/LoaderScreen";
import { CondonacionInteresModal } from "./CondonacionInteresModal";

export const CondonacionInteresMainScreen = () => {
    const history = useHistory();
    const [datos, setDatos] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [selectedUsuario, setSelectedUsuario] = useState(null);
    const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });

    const cargarDatos = () => {
        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get("CondonacionIntereses/ListadoUsuariosCondonacion")
            .then((result) => {
                setDatos(Array.isArray(result) ? result : []);
                setLoader((prev) => ({ ...prev, mostrar: false }));
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire("CONDONACIÓN DE INTERÉS", "No se pudo cargar la información. Intenta nuevamente.", "error");
            });
    };

    useEffect(() => {
        cargarDatos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openModal, openModalEditar]);

    const handleOpenModal = () => setOpenModal(true);
    const handleCloseModal = () => setOpenModal(false);

    const handleOpenModalEditar = (item) => {
        setSelectedUsuario(item);
        setOpenModalEditar(true);
    };
    const handleCloseModalEditar = () => {
        setSelectedUsuario(null);
        setOpenModalEditar(false);
    };

    const onEliminar = (id) => {
        Swal.fire({
            title: "¿Eliminar configuración?",
            text: "Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (!result.isConfirmed) return;
            setLoader((prev) => ({ ...prev, mostrar: true }));
            request
                .post("CondonacionIntereses/Eliminar", { id, eliminado: true })
                .then(() => {
                    Swal.fire("CONDONACIÓN DE INTERÉS", "Configuración eliminada correctamente.", "success");
                    cargarDatos();
                })
                .catch(() => {
                    setLoader((prev) => ({ ...prev, mostrar: false }));
                    Swal.fire("CONDONACIÓN DE INTERÉS", "No se pudo eliminar la configuración.", "error");
                });
        });
    };

    return (
        <div className="crm-main-screen">
            <LoaderScreen loader={loader} />
            <div className="crm-body">
                <div className="crm-page">
                    <div className="crm-module">
                        <div className="crm-module-head">
                            <div className="crm-head-grid">
                                <div className="crm-head-left">
                                    <button className="crm-btn-regresar" onClick={() => history.push("/Permisos/Main")}>
                                        <ArrowBackIcon /> Regresar
                                    </button>
                                </div>
                                <div className="crm-head-center">
                                    <h1 className="crm-module-title">CONDONACIÓN DE INTERÉS</h1>
                                </div>
                                <div className="crm-head-right">
                                    <button className="crm-btn-action" onClick={handleOpenModal}>
                                        <AddCircleOutlineIcon /> <span className="crm-btn-label">Nueva configuración</span>
                                    </button>
                                </div>
                            </div>
                            <div className="crm-head-divider">
                                <div className="crm-head-divider-dot" />
                            </div>
                        </div>

                        <div className="mjr-wrapper scroll">
                            <div className="cdi-panel">
                                <div className="cdi-panel-header">
                                    <div className="cdi-panel-header-icono"><PercentIcon /></div>
                                    <h3 className="cdi-panel-titulo">Usuarios configurados</h3>
                                    <span className="cdi-panel-badge">{datos.length} registros</span>
                                </div>

                                <div className="cdi-tabla-wrap">
                                    <table className="cdi-tabla" cellPadding={0} cellSpacing={0}>
                                        <thead>
                                            <tr>
                                                <th><div>Usuario</div></th>
                                                <th><div className="borde-izq">% máx. interés normal</div></th>
                                                <th><div className="borde-izq">% máx. interés moratorio</div></th>
                                                <th><div className="borde-izq">Autorización</div></th>
                                                <th><div className="borde-izq" style={{ color: "transparent" }}>.</div></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {datos.map((item) => (
                                                <tr key={item.id}>
                                                    <td className="cdi-tabla-usuario">{item.usuario}</td>
                                                    <td className="cdi-tabla-pct">{item.porcentaje_normal}%</td>
                                                    <td className="cdi-tabla-pct">{item.porcentaje_moratorio}%</td>
                                                    <td>
                                                        {item.notificar ? (
                                                            <span className="cdi-badge cdi-badge-on">
                                                                <GppGoodIcon /> Requerida
                                                            </span>
                                                        ) : (
                                                            <span className="cdi-badge cdi-badge-off">
                                                                <GppBadIcon /> No requerida
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td className="cdi-tabla-acciones">
                                                        <button className="cdi-icon-btn" onClick={() => handleOpenModalEditar(item)} title="Editar">
                                                            <EditIcon />
                                                        </button>
                                                        <button className="cdi-icon-btn cdi-icon-btn-eliminar" onClick={() => onEliminar(item.id)} title="Eliminar">
                                                            <DeleteOutlineIcon />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                            {datos.length === 0 && (
                                                <tr>
                                                    <td colSpan={5} className="cdi-tabla-vacio">
                                                        Aún no hay usuarios configurados.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CondonacionInteresModal
                open={openModal}
                onClose={handleCloseModal}
                idConfiguracion={null}
            />
            <CondonacionInteresModal
                open={openModalEditar}
                onClose={handleCloseModalEditar}
                idConfiguracion={selectedUsuario?.id}
            />
        </div>
    );
};

export default CondonacionInteresMainScreen;
